// Libraries
import styled from 'styled-components'
import { ErrorMessage as FormikErrorMessage } from 'formik'
import { Trash } from '@styled-icons/heroicons-outline/Trash'
// Constants
import { ErrorColor } from '../../../constants/constants'

/* Field Components */
export const ErrorMessage = styled(FormikErrorMessage)`
  color: ${ErrorColor};
  width: 100%;
  font-size: .875em;
  margin-top: .25em;
`
export const Label = styled.label`
  align-self: flex-start;
  font-weight: bold;
  margin-bottom: 5px;
`
/* Modal Components */
export const ButtonContainer = styled.div`
  display: flex;
  margin-top: 3rem;
  justify-content: flex-end;
  background: transparent;
  padding-top: 1.5rem;
`

export const FullWidthButtonContainer = styled(ButtonContainer)`
  width: 100%; 
  padding-top: 0; 
  margin-top: 0; 
`
export const FormFieldWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`

export const OptionContainer = styled.div`
  ${(props) => props.showDeleteOption && `
    display: flex;
    justify-content: space-between;
    align-items: center;
  `}
`

export const OptionLabel = styled.div`
  overflow: hidden;
  width: 440px;
  padding: 0px;
  margin: 0px;
`
export const OptionTrashIcon = styled(Trash)`
  color: #de411b;
  width: 20px;
  height: 20px;
`
